<div class="ticker d-flex align-items-center">
    <ng-select 
    class="ticker-select w-100" placeholder="Search a Ticker"
    bindLabel="ticker" 
    [trackByFn]="trackByFn"
    [loading]="tikcerLoading"
    [typeahead]="tickerInput$"
    [(ngModel)]="selectedTicker"
    (ngModelChange)="tickerChange($event)">
    <ng-option *ngFor="let ticker of tickers$ | async" [value]="ticker.ticker">
        <img
        class="rounded-circle mr-1"
        [src]="'assets/images/ticker-icons/'+ticker?.ticker.toString().toUpperCase()+'.png'"
        class="mr-75"
        height="32"
        width="32"
      />
        {{ticker.ticker}}
    </ng-option>
  </ng-select>
</div>